import { useEffect, useState } from "react";

import axios from "axios";

import { PageConfig, PageKey } from "../../types/strapi/PageConfig";

export function usePageConfig() {
  const [pageConfig, setPageConfig] = useState<PageConfig[] | null>(null);

  const endpoint = `${process.env.REACT_APP_STRAPI_BASE_URL}/api/page-configs`;

  async function fetchPageConfig() {
    try {
      const res = await axios.get(endpoint, {
        headers: {
          Authorization: `bearer ${process.env.REACT_APP_API_KEY_CMS}`,
        },
      });

      const dataList = res.data?.data;

      if (!dataList || dataList.length === 0) {
        console.warn("No page config found:", dataList);
        setPageConfig(null);
        return;
      }

      // map each item to PageConfig shape
      const formatted = dataList.map((data: PageConfig) => ({
        pageKey: data.pageKey as PageKey,
        order: data.order,
        isEnabledPage: data.isEnabledPage,
        globalConfig: data.globalConfig || [],
        partnerPageConfigs: data.partnerPageConfigs || [],
      }));

      setPageConfig(formatted);
    } catch (err) {
      console.error("Failed to fetch partner config:", err);
      setPageConfig(null);
    }
  }

  useEffect(() => {
    fetchPageConfig();
  }, [endpoint]);

  return pageConfig;
}
